var _circle, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _circle2, _path12, _path13, _path14, _path15, _ellipse5, _circle3, _path16, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle4, _rect16, _rect17, _ellipse6, _ellipse7, _circle5, _circle6, _path17, _ellipse8, _ellipse9, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErroComunicacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_543",
    "data-name": "Grupo 543",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1119.609,
    height: 699,
    viewBox: "0 0 1119.609 699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_22",
    "data-name": "Elipse 22",
    cx: 213,
    cy: 213,
    r: 213,
    transform: "translate(79.609)",
    fill: "#c1d837"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7073",
    "data-name": "Caminho 7073",
    d: "M31.391,151.642c0,77.5,48.618,140.208,108.7,140.208",
    transform: "translate(-31.391 -100.5)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7074",
    "data-name": "Caminho 7074",
    d: "M140.092,291.851c0-78.369,54.255-141.784,121.3-141.784",
    transform: "translate(-31.391 -100.5)",
    fill: "#c9da61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7075",
    "data-name": "Caminho 7075",
    d: "M70.775,158.668c0,73.615,31,133.183,69.316,133.183",
    transform: "translate(-31.391 -100.5)",
    fill: "#c9da61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7076",
    "data-name": "Caminho 7076",
    d: "M140.092,291.851c0-100.138,62.71-181.168,140.208-181.168",
    transform: "translate(-31.391 -100.5)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7077",
    "data-name": "Caminho 7077",
    d: "M117.224,292.839s15.416-.475,20.061-3.783S161,281.8,162.151,287.1s23.167,26.388,5.763,26.529-40.439-2.711-45.076-5.535S117.224,292.839,117.224,292.839Z",
    transform: "translate(-31.391 -100.5)",
    fill: "#a8a8a8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7078",
    "data-name": "Caminho 7078",
    d: "M168.224,311.785c-17.4.14-40.439-2.711-45.076-5.535-3.531-2.151-4.938-9.869-5.409-13.43-.326.014-.515.02-.515.02s.976,12.433,5.613,15.257,27.672,5.676,45.076,5.535c5.024-.041,6.759-1.828,6.664-4.475C173.879,310.756,171.963,311.755,168.224,311.785Z",
    transform: "translate(-31.391 -100.5)",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_23",
    "data-name": "Elipse 23",
    cx: 187,
    cy: 25.44,
    rx: 187,
    ry: 25.44,
    transform: "translate(11.609 399.06)",
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_24",
    "data-name": "Elipse 24",
    cx: 157,
    cy: 21.359,
    rx: 157,
    ry: 21.359,
    transform: "translate(41.609 403.141)",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_25",
    "data-name": "Elipse 25",
    cx: 283,
    cy: 38.5,
    rx: 283,
    ry: 38.5,
    transform: "translate(553.609 622)",
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 170,
    cy: 23.127,
    rx: 170,
    ry: 23.127,
    transform: "translate(140.609 622.373)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7079",
    "data-name": "Caminho 7079",
    d: "M494,726.5c90,23,263-30,282-90",
    transform: "translate(-31.391 -100.5)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7080",
    "data-name": "Caminho 7080",
    d: "M341,359.5s130-36,138,80-107,149-17,172",
    transform: "translate(-31.391 -100.5)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7081",
    "data-name": "Caminho 7081",
    d: "M215.4,637.783s39.072-10.82,41.477,24.044-32.16,44.783-5.109,51.7",
    transform: "translate(-31.391 -100.5)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7082",
    "data-name": "Caminho 7082",
    d: "M810.1,663.74l-7.878,50.295s-38.782,20.6-11.513,21.209,155.733,0,155.733,0,24.845,0-14.543-21.815l-7.878-52.719Z",
    transform: "translate(-31.391 -100.5)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7083",
    "data-name": "Caminho 7083",
    d: "M785.219,734.7c6.193-5.51,17-11.252,17-11.252l7.878-50.3,113.922.107L931.9,722.84c9.185,5.087,14.875,8.987,18.2,11.978,5.059-1.154,10.587-5.444-18.2-21.389l-7.878-52.719L810.1,663.74l-7.877,50.3S769.63,731.35,785.219,734.7Z",
    transform: "translate(-31.391 -100.5)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_86",
    "data-name": "Ret\\xE2ngulo 86",
    width: 513.253,
    height: 357.52,
    rx: 18.046,
    transform: "translate(578.433 212.689)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_87",
    "data-name": "Ret\\xE2ngulo 87",
    width: 478.713,
    height: 267.837,
    transform: "translate(595.703 231.777)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_27",
    "data-name": "Elipse 27",
    cx: 3.03,
    cy: 3.03,
    r: 3.03,
    transform: "translate(832.03 220.263)",
    fill: "#1abfd5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7084",
    "data-name": "Caminho 7084",
    d: "M1123.08,621.322v31.341a18.044,18.044,0,0,1-18.048,18.046H627.87a18.044,18.044,0,0,1-18.046-18.048V621.322Z",
    transform: "translate(-31.391 -100.5)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7085",
    "data-name": "Caminho 7085",
    d: "M968.978,667.466v6.06H642.968v-4.848l.449-1.212,8.035-21.815h310.86Z",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7086",
    "data-name": "Caminho 7086",
    d: "M1125.83,762.034c-.594,2.539-2.836,5.217-7.9,7.75-18.179,9.089-55.143-2.424-55.143-2.424s-28.48-4.848-28.48-17.573a22.726,22.726,0,0,1,2.5-1.485c7.643-4.044,32.984-14.021,77.918.422a18.739,18.739,0,0,1,8.541,5.6C1125.08,756.454,1126.51,759.157,1125.83,762.034Z",
    transform: "translate(-31.391 -100.5)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7087",
    "data-name": "Caminho 7087",
    d: "M1125.83,762.034c-22.251,8.526-42.084,9.162-62.439-4.975-10.265-7.126-19.591-8.89-26.59-8.756,7.643-4.044,32.984-14.021,77.918.422a18.739,18.739,0,0,1,8.541,5.6C1125.08,756.454,1126.51,759.157,1125.83,762.034Z",
    transform: "translate(-31.391 -100.5)",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_28",
    "data-name": "Elipse 28",
    cx: 7.878,
    cy: 2.424,
    rx: 7.878,
    ry: 2.424,
    transform: "translate(1058.662 651.711)",
    fill: "#1abfd5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_29",
    "data-name": "Elipse 29",
    cx: 11.513,
    cy: 11.513,
    r: 11.513,
    transform: "translate(823.547 534.154)",
    fill: "#1abfd5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7088",
    "data-name": "Caminho 7088",
    d: "M968.978,667.466v6.06H642.968v-4.848l.449-1.212Z",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_88",
    "data-name": "Ret\\xE2ngulo 88",
    width: 208,
    height: 242,
    transform: "translate(108.609 159)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_89",
    "data-name": "Ret\\xE2ngulo 89",
    width: 250,
    height: 86,
    transform: "translate(87.609 135)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_90",
    "data-name": "Ret\\xE2ngulo 90",
    width: 250,
    height: 86,
    transform: "translate(87.609 237)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_91",
    "data-name": "Ret\\xE2ngulo 91",
    width: 250,
    height: 86,
    transform: "translate(87.609 339)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_92",
    "data-name": "Ret\\xE2ngulo 92",
    width: 16,
    height: 16,
    transform: "translate(271.609 150)",
    fill: "#c9da61",
    opacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_93",
    "data-name": "Ret\\xE2ngulo 93",
    width: 16,
    height: 16,
    transform: "translate(294.609 150)",
    fill: "#c9da61",
    opacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_94",
    "data-name": "Ret\\xE2ngulo 94",
    width: 16,
    height: 16,
    transform: "translate(317.609 150)",
    fill: "#c9da61"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_95",
    "data-name": "Ret\\xE2ngulo 95",
    width: 16,
    height: 16,
    transform: "translate(271.609 251)",
    fill: "#c9da61",
    opacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_96",
    "data-name": "Ret\\xE2ngulo 96",
    width: 16,
    height: 16,
    transform: "translate(294.609 251)",
    fill: "#c9da61",
    opacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_97",
    "data-name": "Ret\\xE2ngulo 97",
    width: 16,
    height: 16,
    transform: "translate(317.609 251)",
    fill: "#c9da61"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_98",
    "data-name": "Ret\\xE2ngulo 98",
    width: 16,
    height: 16,
    transform: "translate(271.609 352)",
    fill: "#c9da61",
    opacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_99",
    "data-name": "Ret\\xE2ngulo 99",
    width: 16,
    height: 16,
    transform: "translate(294.609 352)",
    fill: "#c9da61",
    opacity: 0.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_100",
    "data-name": "Ret\\xE2ngulo 100",
    width: 16,
    height: 16,
    transform: "translate(317.609 352)",
    fill: "#c9da61"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_30",
    "data-name": "Elipse 30",
    cx: 79,
    cy: 79,
    r: 79,
    transform: "translate(237.609 459)",
    fill: "#eea886"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_101",
    "data-name": "Ret\\xE2ngulo 101",
    width: 24,
    height: 43,
    transform: "translate(280.609 600)",
    fill: "#eea886"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_102",
    "data-name": "Ret\\xE2ngulo 102",
    width: 24,
    height: 43,
    transform: "translate(328.609 600)",
    fill: "#eea886"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_31",
    "data-name": "Elipse 31",
    cx: 20,
    cy: 7.5,
    rx: 20,
    ry: 7.5,
    transform: "translate(280.609 636)",
    fill: "#eea886"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_32",
    "data-name": "Elipse 32",
    cx: 20,
    cy: 7.5,
    rx: 20,
    ry: 7.5,
    transform: "translate(328.609 635)",
    fill: "#eea886"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_33",
    "data-name": "Elipse 33",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(291.609 491)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_34",
    "data-name": "Elipse 34",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(309.609 509)",
    fill: "#c1d837"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7089",
    "data-name": "Caminho 7089",
    d: "M271.367,565.032c-6.379-28.568,14.012-57.434,45.544-64.475s62.265,10.41,68.644,38.978-14.519,39.1-46.051,46.145S277.746,593.6,271.367,565.032Z",
    transform: "translate(-31.391 -100.5)",
    fill: "#c1d837"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_35",
    "data-name": "Elipse 35",
    cx: 39.5,
    cy: 12.4,
    rx: 39.5,
    ry: 12.4,
    transform: "translate(344.63 514.984) rotate(-23.171)",
    fill: "#eea886"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_36",
    "data-name": "Elipse 36",
    cx: 39.5,
    cy: 12.4,
    rx: 39.5,
    ry: 12.4,
    transform: "translate(196.631 567.984) rotate(-23.171)",
    fill: "#eea886"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7090",
    "data-name": "Caminho 7090",
    d: "M394,661.5c0,7.732-19.909,23-42,23s-43-14.268-43-22,20.909-6,43-6S394,653.768,394,661.5Z",
    transform: "translate(-31.391 -100.5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroComunicacao);
export default __webpack_public_path__ + "static/media/erro_comunicacao.2c5d1f6084b95d2bb80b441d8e73eb7a.svg";
export { ForwardRef as ReactComponent };